export namespace NNotificationModal {
    /**
     * Modal identifier
     */
    export const id = 'notification';
    /**
     * Data passet to modal
     */
    export interface IModalData {
        title: string;
        message: string;
    }
}
